import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@material-ui/core"
import {ExpandMore as ExpandMoreIcon, Info as InfoIcon} from "@material-ui/icons"

import {CustomerInstalmentOverrideAppliedActivityPayload} from "@indebted/api"

function InstalmentOverrideAppliedActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {Title: string; HappenedAt: string; Payload: CustomerInstalmentOverrideAppliedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<InfoIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>
								Weekly Max Duration Override:
							</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.WeeklyMaxDurationOverride}
							</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Payment Amount:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.Currency} {(Payload.PaymentAmount / 100).toFixed(2)}
							</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Applied At Balance:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.Currency} {(Payload.AppliedAtBalance / 100).toFixed(2)}
							</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Agent Email:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.AgentEmail}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {InstalmentOverrideAppliedActivity}
